import React from 'react';
import Highlight from './Highlight';
import Bitmap from '../assets/images/Bitmap.png';
import Button from './Button';
import ShadowContainer from './ShadowContainer';
import { useNavigate } from 'react-router-dom';

const IntroSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/request');
  };

  return (
    <div style={styles.introSection}>
      <div style={styles.textWrapper}>
        <Highlight width={619} height={344} />
        <div style={styles.textBox}>
          <h2 style={styles.heading}>Tražiš deo za auto? <br /> Mi imamo rešenje!</h2>
          <p style={styles.subtext}>
            Pronađi najpovoljnije delove za svoj automobil. <br /> Popuni zahtev i odaberi najpovoljniju ponudu!
          </p>
          <Button
            width={250}
            height={80}
            borderColor="yellow"
            backgroundColor="#d3e205"
            text="Zatraži deo"
            onClick={handleButtonClick}
          />
        </div>
      </div>
      <ShadowContainer
        Image={Bitmap}
        width={640}
        height={672}
        imageStyle={styles.shadowContainer}
      />
    </div>
  );
};

export default IntroSection;

const styles = {
  introSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(23, 23, 24)',
    padding: 40,
    gap: 40,
    flexWrap: 'wrap',
    position: 'relative',
    marginTop: '100px',
    marginBottom: '100px',
  },
  textWrapper: {
    position: 'relative',
    width: 619,
    height: 344,
    zIndex: 0,
  },
  textBox: {
    position: 'relative',
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: 20,
    borderRadius: 12,
    width: 619,
    height: 344,
    zIndex: 2,
    backdropFilter: 'blur(6px)',
  },
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 16,
    lineHeight: '64px',
  },
  subtext: {
    fontSize: '18px',
    color: '#ccc',
    lineHeight: '28px',
    marginBottom: 24,
  },
  shadowContainer: {
    objectPosition: 'top'
  }
};
